'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Filler } from 'chart.js';
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Filler);
const RegistrationTrendChart = ({ title, data, height = 280, fillParent, yMin = 0, yMax = 2000, yStep = 500 }) => {
    const theme = useTheme();
    const chartData = useMemo(() => ({
        labels: data.map((d) => d.label),
        datasets: [
            {
                label: 'Registrations',
                data: data.map((d) => d.value),
                borderColor: theme.palette.primary.main,
                backgroundColor: theme.palette.primary.light
                    ? `${theme.palette.primary.light}80`
                    : 'rgba(25, 118, 210, 0.25)',
                fill: true,
                tension: 0.35,
                borderWidth: 2,
                pointRadius: 0,
                pointHoverRadius: 4,
                pointBackgroundColor: theme.palette.primary.main
            }
        ]
    }), [data, theme]);
    const options = useMemo(() => ({
        responsive: true,
        maintainAspectRatio: false,
        // Hover ("active" element) transitions animate by default in Chart.js, separately from
        // the initial draw-in animation. Disabling just this keeps hover response instant without
        // affecting the load-in animation.
        transitions: {
            active: {
                animation: { duration: 0 }
            }
        },
        plugins: {
            legend: { display: false },
            tooltip: {
                mode: 'index',
                intersect: false,
                backgroundColor: theme.palette.grey[800],
                titleColor: theme.palette.common.white,
                bodyColor: theme.palette.common.white,
                cornerRadius: 8,
                padding: 10
            }
        },
        scales: {
            x: {
                grid: { display: false },
                ticks: {
                    display: true,
                    color: theme.palette.text.secondary,
                    font: { size: 11 }
                },
                border: { display: false }
            },
            y: {
                min: yMin,
                max: yMax,
                grid: {
                    display: true,
                    color: theme.palette.divider
                },
                ticks: {
                    stepSize: yStep,
                    color: theme.palette.text.secondary,
                    font: { size: 11 }
                },
                border: { display: false }
            }
        }
    }), [theme, yMin, yMax, yStep]);
    return (_jsxs(Box, { sx: { display: 'flex', flexDirection: 'column', height: '100%' }, children: [title && (_jsx(Typography, { variant: 'h6', sx: { fontWeight: 500, color: theme.palette.text.primary, mb: 2 }, children: title })), _jsx(Box, { sx: {
                    flex: 1,
                    minHeight: 0,
                    height: fillParent ? '100%' : height
                }, children: _jsx(Line, { data: chartData, options: options }) })] }));
};
export default RegistrationTrendChart;
